import { ContainerMeasurement } from 'app/features/manual-input-result-registration/models/container-measurement';
import { ProductBox } from 'app/shared/components/product-box/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { Container } from 'app/shared/features/container-selector/models';

export function getAmountResultMessage(
    containerMeasurement: ContainerMeasurement,
    activity: Activity | undefined,
) {
    return `Weight ${containerMeasurement.amountResult} ${activity?.registrationUnit ?? ''}`;
}

export function getContainerMessage(container: Container | undefined) {
    return `Container ${container?.number}`;
}

export function getProductBoxMessage(
    containerMeasurement: ContainerMeasurement,
    productBox: (ProductBox | undefined)[],
) {
    let message = '';
    for (let i = 0; i < productBox.length; i++) {
        if (i === 0) {
            message += `${containerMeasurement.productBoxRegistrations[i].amount ?? ''} ${productBox[i]?.name}`;
        } else if (i === 1) {
            message += `, ${containerMeasurement.productBoxRegistrations[i].amount} ${productBox[i]?.name}`;
            if (productBox.length > 2) {
                message += ` ...`;
                break;
            }
        }
    }
    return message;
}

export function getContainerMeasurementMessage(
    containerMeasurement: ContainerMeasurement,
    activity: Activity | undefined,
    productBox: (ProductBox | undefined)[],
    container: Container | undefined,
) {
    let toasterMessageDetails = '';

    // Set message for additional information based on measurement type
    // byAmount
    if (containerMeasurement.amountResult) {
        toasterMessageDetails =
            getContainerMessage(container) + '<br/>' + getAmountResultMessage(containerMeasurement, activity);
    } // byProductBox
    else if (containerMeasurement.productBoxRegistrations.length > 0 && productBox) {
        toasterMessageDetails =
            getContainerMessage(container) + '<br/>' + getProductBoxMessage(containerMeasurement, productBox);
    }
    return `${activity?.name}<br/>${toasterMessageDetails}`;
}
